const QuantityMode = Object.freeze({
    BY_UNIT: 'byUnit',
    HALF_PALLET: 'halfPallet',
    BY_PALLET: 'byPallet',
  });


// logic relies on existing variant pickers and qty selector  
class QuantityByUnit extends HTMLElement {
  constructor() {
    super();

    this.mode = QuantityMode.BY_UNIT;
    this.regularQuantity = document.querySelector("[data-js-product-quantity]");
    this.regularQuantityInput = this.regularQuantity.querySelector("input");
    this.palletQuantity = document.querySelector("[data-js-pallet-quantity]");
    this.palletQuantityInput = this.palletQuantity.querySelector("input");

    this.halfPalletCount = Number(this.dataset.halfPalletCount);
    this.palletCount = Number(this.dataset.palletCount);

    this.byUnitSelector = this.querySelector("#QBY-ByUnit");
    this.halfPalletSelector = this.querySelector("#QBY-HalfPallet");
    this.palletSelector = this.querySelector("#QBY-Pallet");

    this.variantLabels = document.querySelector("[data-js-product-variant-container]").querySelectorAll("[data-unit-count]");

    this.lastPriceBreakBeforeHalfPallet = Number(this.variantLabels[0].dataset.unitCount); // pricing between last price break and half pallet will be treated the same as the pricing at the last price break
    this.variantLabels.forEach((variantLabel) => {
        if(Number(variantLabel.dataset.unitCount) < this.dataset.halfPalletCount) this.lastPriceBreakBeforeHalfPallet = Number(variantLabel.dataset.unitCount)
    });
  }

  connectedCallback() {
    this.hidePalletQuantity();
    this.regularQuantityInput.addEventListener("change", this.onQuantityInputUpdated.bind(this));
    this.regularQuantityInput.addEventListener("inputChangedByButtons", this.onQuantityInputUpdated.bind(this));

    this.palletQuantityInput.addEventListener("change", this.onPalletQuantityInputUpdated.bind(this));
    this.palletQuantityInput.addEventListener("inputChangedByButtons", this.onPalletQuantityInputUpdated.bind(this));

    this.byUnitSelector.addEventListener("click", this.onByUnitSelected.bind(this));
    this.halfPalletSelector.addEventListener("click", this.onHalfPalletSelected.bind(this));
    this.palletSelector.addEventListener("click", this.onPalletSelected.bind(this));
  }

  updatePricing() {    
    const quantity = this.regularQuantityInput.value;
    if (quantity < this.lastPriceBreakBeforeHalfPallet) return;
    const priceWrapper = document.querySelector("[data-js-price-total]");
    if (!priceWrapper) return;
    const variantPriceRaw = priceWrapper.dataset.variantPriceRaw;

    priceWrapper.innerHTML = `<span>(${quantity}) ${priceWrapper.getAttribute("data-bag-word")}(s) – </span><span style="display: none">${this.formatMoney(variantPriceRaw * quantity, KROWN.settings.shop_money_format)}</span>`;
  }

  onByUnitSelected() {
    this.mode = QuantityMode.BY_UNIT;

    this.resetQuantity();
    this.showRegularQuantity();
    this.hidePalletQuantity();
    
    this.updateSelectedVariants(1);
  }

  onHalfPalletSelected() {
    this.mode = QuantityMode.HALF_PALLET;

    this.hideRegularQuantity();
    this.hidePalletQuantity();
    this.updateQuantity(this.halfPalletCount);

    this.updateSelectedVariants(this.halfPalletCount);
  }

  onPalletSelected() {
    this.mode = QuantityMode.BY_PALLET;

    this.hideRegularQuantity();
    this.showPalletQuantity();
    this.updateQuantity(this.palletCount);

    this.updateSelectedVariants(this.palletCount);
  }

  updateSelectedVariants(unit) {
    console.log("updateSelectedVariants")
    if(unit > this.lastPriceBreakBeforeHalfPallet && unit < this.halfPalletCount) unit = this.lastPriceBreakBeforeHalfPallet;

    let labelToSelect;
    this.variantLabels.forEach((variantLabel) => {
        if(variantLabel.dataset.unitCount == unit) 
            labelToSelect = variantLabel;
    });
    if(labelToSelect) labelToSelect.click();
  }

  onPalletQuantityInputUpdated(e) {
    const value = e.target.value;

    this.updateQuantity(value * this.palletCount);      
    this.updatePricing();
  }

  onQuantityInputUpdated(e) {
    let value = e.target.value;
    if(Number(value) > Number(this.regularQuantityInput.max)) {
      value = this.regularQuantityInput.max;
      this.regularQuantityInput.value = value;
    }
    if(Number(value) > this.lastPriceBreakBeforeHalfPallet) {
      this.updatePricing();
      return;
    }

    this.updateSelectedVariants(value);
  }

  showRegularQuantity() {
    this.regularQuantity.parentElement.classList.remove('hide');
  }

  hideRegularQuantity() {
    this.regularQuantity.parentElement.classList.add('hide');
  }

  showPalletQuantity() {
    this.palletQuantity.classList.remove('hide');
  }

  hidePalletQuantity() {
    // this.palletQuantity.classList.add('hide');
  }

  updateQuantity(quantity) {
    this.regularQuantityInput.value = quantity;
  }

  onPalletQuantityChanged(value) {
    this.updateQuantity(value * this.palletCount);
  }

  resetQuantity() {
    this.updateQuantity(1);
  }

  formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
  
    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || moneyFormat;
  
    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';
  
      if (isNaN(number) || number === null) {
        return 0;
      }
  
      number = (number / 100.0).toFixed(precision);
  
      const parts = number.split('.');
      const dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      const centsAmount = parts[1] ? decimal + parts[1] : '';
  
      return dollarsAmount + centsAmount;
    }
  
    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }
  
    return formatString.replace(placeholderRegex, value);
  }
}

customElements.define("quantity-by-unit", QuantityByUnit);
